<div *ngIf="isVisible" class="event-list left-first-level-container" [@openClose]>

    <!-- header-->
    <div class="event-list__header">
        <span class="event-list-lite-label">{{'events-list.header' | translate}}</span>
        <div class="btn-close" [routerLink]="['/panel' , 'main']"></div>
    </div>

    <!-- tabs -->
    <div class="event-list__tabs">
        <div *ngIf="isAlarmsTabEnabled" class="event-list__tab" (click)="goToTab(EventType.Alarm)"
            [ngClass]="getStyleClassForTab(EventType.Alarm)">
            <span class="event-list__tab-name">{{'events-list.alarm' | translate}}</span>
            <span class="event-list__unread"></span>
        </div>
        <div *ngIf="isFuelTabEnabled" class="event-list__tab" (click)="goToTab(EventType.Fuel)"
            [ngClass]="getStyleClassForTab(EventType.Fuel)">
            <span class="event-list__tab-name">{{'labels.fuel' | translate | titlecase}}</span>
            <span class="event-list__unread"></span>
        </div>
        <div *ngIf="isAreasTabEnabled" class="event-list__tab" (click)="goToTab(EventType.Area)"
            [ngClass]="getStyleClassForTab(EventType.Area)">
            <span class="event-list__tab-name">{{'labels.areas' | translate | titlecase}}</span>
            <span class="event-list__unread"></span>
        </div>
    </div>

    <div class="event-list__filters">
        <app-filters-events
            (toogleDatePicker$)="isVisibleDatepicker = !isVisibleDatepicker"
            [isVisibleDatepicker]="isVisibleDatepicker"
            [selectedDatesInCalendar]="selectedDatesInCalendar"
            [form]="formFilters"
            [selectedTab]="eventType"
        ></app-filters-events>
    </div>

    <div class="event-list__content">
        <div *ngIf="isLoadingData" class="event-list__skeleton">
            <p-skeleton *ngFor="let item of [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]" height="5rem"></p-skeleton>
        </div>

        <ng-container *ngIf="!isLoadingData && eventsList.length">
            <app-event-list *ngIf="eventType === EventType.Alarm" [listEventType]="eventType" [data]="eventsList"></app-event-list>
            <app-event-list *ngIf="eventType === EventType.Fuel" [listEventType]="eventType" [data]="eventsList"></app-event-list>
            <app-event-list *ngIf="eventType === EventType.Area" [listEventType]="eventType" [data]="eventsList"></app-event-list>
        </ng-container>

        <div *ngIf="!isLoadingData && !eventsList?.length" class="event-list__content__empty-state">
          <img src="/assets/img/empty-state-events.svg" alt="">
          <span class="event-list__content__empty-state__title">
            {{ 'emptyStateEvents' | translate }}
          </span>
          <span class="event-list__content__empty-state__desc">
            {{ 'emptyStateEventsDescription' | translate }}
          </span>
        </div>

        <div *ngIf="isVisibleDatepicker" class="event-list__content__datepicker">
            <app-vehicle-details-routes-calendar
                (onHideCalendar)="isVisibleDatepicker = false"
                (onSubmitCalendar)="onSelectDaysInCalendar($event)"
                [isVisible]="isVisibleDatepicker"
            ></app-vehicle-details-routes-calendar>
        </div>
    </div>
</div>
